<form 
    (ngSubmit)="$event.preventDefault(); saveRoarDetails();"
    [formGroup]="roarDetailsForm"
    class="w-full h-full flex flex-col items-center justify-start gap-4 overflow-y-auto"
>
    <div class="w-full overflow-y-auto px-1">                    
        <h2 class="pb-2 w-full oswald-font text-xl font-medium text-start">
            ROAR Activity
        </h2>

        <div class="w-full flex flex-col items-center gap-4 pb-4">        
            <div class="w-full flex flex-col items-center text-start">
                <review-roar-activity class="w-full h-full" *ngIf="this.roarAssignmentFormData" [roarId]="this.roarAssignmentFormData.roar_id"></review-roar-activity>
            </div>                   
            <h2 class="pb-2 w-full oswald-font text-xl font-medium text-start">
                ROAR Activity Review
            </h2>
            <div class="w-full flex flex-col items-start text-start" *ngFor="let question of questionList">
                <div class="w-full font-semibold">
                    <p>{{ question.question }}</p>
                </div>
                <div class="w-full flex flex-col items-center">
                    <textarea 
                        *ngIf="question.type === 'textarea'"
                        [formControlName]="question.formControlName"
                        rows="3"
                        class="block p-2 w-full text-sm text-gray-900 bg-gray-50 rounded border border-gray-300"
                        placeholder="Type here"
                    ></textarea>

                    <input 
                        *ngIf="question.type === 'text'"
                        type="text"
                        [formControlName]="question.formControlName"
                        class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded block w-full p-2"
                        placeholder="Type here"
                    >
                </div>
            </div>
        </div>
        <div class="w-full flex flex-row gap-2 items-center justify-end">
            <button
                type="submit"
                class="w-20 flex items-center justify-center px-4 py-1.5 rounded-md border bg-gradient-to-b oswald-font text-white"
                [ngClass]="{
                    'border-nside-gray-100 from-nside-gray-100 to-nside-gray-200 cursor-not-allowed': this.roarDetailsForm.invalid,
                    'border-nside-orange-100 from-nside-orange-300 to-nside-orange-400 hover:bg-gradient-to-b hover:from-nside-orange-100 hover:to-nside-orange-200': this.roarDetailsForm.valid
                }"
                [disabled]="this.roarDetailsForm.invalid"
            >
                Save
            </button>
        </div>
    </div>
</form>